import { render, staticRenderFns } from "./ViewingAppointmentSenderEmailSettings.vue?vue&type=template&id=d7971ebc"
import script from "./ViewingAppointmentSenderEmailSettings.vue?vue&type=script&lang=js"
export * from "./ViewingAppointmentSenderEmailSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports